import _styled from "styled-components";
import React from "react";
import { usePathCreator } from "../Config/useLinkCreator";
import { Header } from "../Header/Header";

var Container = _styled.div.withConfig({
  displayName: "FAQPage__Container",
  componentId: "r7wcrj-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "FAQPage__Title",
  componentId: "r7wcrj-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

export function FAQPage() {
  var pathCreator = usePathCreator();
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/help")
  }), /*#__PURE__*/React.createElement(Title, null, "FAQ"));
}